import { MY_ORDERS_V4_241021 } from "@faire/web-api/indigofair/settings/MY_ORDERS_V4_241021";

import { useSetting } from "./__internal__/useSetting";

export const useSettingMyOrdersV4 = (): boolean =>
  useSetting(MY_ORDERS_V4_241021, false);
